import { render } from "./BulkAddModal.vue?vue&type=template&id=009b6cf9&scoped=true"
import script from "./BulkAddModal.vue?vue&type=script&lang=js"
export * from "./BulkAddModal.vue?vue&type=script&lang=js"

import "./BulkAddModal.vue?vue&type=style&index=0&id=009b6cf9&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009b6cf9"]])

export default __exports__